import { withCompInfo } from '../../core/withCompInfo'
import { CustomElementComponentDefinition, CustomElementCompoentCSSVars } from './types'

export const props = withCompInfo<{}, CustomElementComponentDefinition>(
	['compData'],
	({ compData: { tagName, url, initialAttributes, hostedInCorvid } }) => {
		return { tagName, url, initialAttributes, hostedInCorvid }
	}
)

export const css = withCompInfo<CustomElementCompoentCSSVars, CustomElementComponentDefinition>(
	['compLayout'],
	({ compLayout: { width, height } }) => ({
		width: 'auto',
		height: 'auto',
		'--customElementWidth': `${width}px`,
		'--customElementHeight': `${height}px`,
	})
)
